import React, { useState } from 'react';
import { User, Mail, Phone, Clock, Users, UserCheck, ExternalLink } from 'lucide-react';

const Team = () => {
  const [activeShift, setActiveShift] = useState<'all' | 'morning' | 'evening' | 'night'>('all');
  
  // Team data organized by shifts
  const teamData = {
    morning: [
      { 
        id: 1, 
        name: 'Team Memeber 1', 
        shift: 'Morning',
        email: '.pk', 
        phone: '+92331-000000',
        avatar: 'https://pub-0f77feecf89849e2bd80779e26ad94bb.r2.dev/female.png',
        role: 'SOC Analyst'
      },
      { 
        id: 2, 
        name: 'Team Member 2', 
        shift: 'Morning',
        email: '.pk', 
        phone: '+92333-0000008',
        avatar: 'https://pub-0f77feecf89849e2bd80779e26ad94bb.r2.dev/female.png',
        role: 'SOC Analyst'
      },
      { 
        id: 3, 
        name: 'Team Memeber 3', 
        shift: 'Morning',
        email: '.pk', 
        phone: '+923070480886',
        avatar: 'https://pub-0f77feecf89849e2bd80779e26ad94bb.r2.dev/female.png',
        role: 'SOC Analyst'
      }
    ],
    evening: [
      { 
        id: 4, 
        name: 'Team Member 4', 
        shift: 'Evening',
        email: '.pk', 
        phone: '+9230-000000',
        avatar: 'https://pub-0f77feecf89849e2bd80779e26ad94bb.r2.dev/female.png',
        role: 'SOC Analyst'
      },
      { 
        id: 5, 
        name: 'Team Member 5', 
        shift: 'Evening',
        email: '.pk', 
        phone: '+92323-000000',
        avatar: 'https://pub-0f77feecf89849e2bd80779e26ad94bb.r2.dev/female.png',
        role: 'SOC Analyst'
      }
    ],
    night: [
      { 
        id: 6, 
        name: 'Team Member 6', 
        shift: 'Night',
        email: 'ahmad@shieldxsecurity.com.pk', 
        phone: '+92340-2512408',
        avatar: 'https://pub-0f77feecf89849e2bd80779e26ad94bb.r2.dev/female.png',
        role: 'SOC Analyst'
      },
      { 
        id: 7, 
        name: 'Team Member 7', 
        shift: 'Night',
        email: 'asad@shieldxsecurity.com.pk', 
        phone: '+92302-0141903',
        avatar: 'https://pub-0f77feecf89849e2bd80779e26ad94bb.r2.dev/female.png',
        role: 'SOC Analyst & PenTester'
      }
    ],
    head: { 
      id: 8, 
      name: 'Lead Member 8', 
      shift: '24/7',
      email: '.pk', 
      phone: '+923078503809',
      avatar: 'https://pub-0f77feecf89849e2bd80779e26ad94bb.r2.dev/female.png',
      role: 'Head of SOC Department'
    }
  };

  // Filter team members based on active shift
  const getVisibleTeamMembers = () => {
    if (activeShift === 'all') {
      return [
        ...teamData.morning,
        ...teamData.evening,
        ...teamData.night
      ];
    }
    return teamData[activeShift];
  };

  return (
    <main className="container mx-auto px-3 sm:px-6 py-4 sm:py-8 relative">
      {/* HUD-Style Top Bar */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 sm:mb-10 p-1 border border-red-900/30 rounded-md bg-black/30 backdrop-blur-sm">
        <div className="flex flex-wrap items-center gap-2 px-2 py-2 sm:py-0 sm:gap-4 sm:px-4">
          <div className="text-red-500 font-mono text-xs sm:text-sm">
            <span className="text-slate-400">TEAM:</span> ACTIVE
          </div>
          <div className="text-red-500 font-mono text-xs sm:text-sm">
            <span className="text-slate-400">SHIFTS:</span> 3
          </div>
          <div className="text-red-500 font-mono text-xs sm:text-sm">
            <span className="text-slate-400">STATUS:</span> OPERATIONAL
          </div>
        </div>
        <div className="flex items-center px-2 py-2 sm:py-0">
          <div className="h-2 bg-gradient-to-r from-red-900 via-red-600 to-red-900 animate-pulse mx-2 sm:mx-4" style={{ width: '60px', maxWidth: '25vw' }}></div>
          <div className="text-red-400 font-mono text-xs px-2 sm:px-4">
            <span className="text-slate-500">TIME:</span> {new Date().toLocaleTimeString()}
          </div>
        </div>
      </div>

      {/* Page Header */}
      <div className="mb-8 sm:mb-12">
        <h1 className="text-2xl sm:text-4xl font-bold mb-1 relative">
          SOC Team <span className="text-red-500">Members</span>
          <div className="absolute -top-2 -right-2 w-2 h-2 bg-red-600 rounded-full animate-ping"></div>
        </h1>
        <div className="flex flex-wrap items-center gap-2 text-red-400 text-xs sm:text-base mb-4">
          <Users className="h-4 w-4 sm:h-5 sm:w-5" />
          <span>Security Operations Center</span>
          <span className="w-1.5 h-1.5 rounded-full bg-red-500 hidden sm:block"></span>
          <span className="hidden sm:inline">24/7 Support</span>
          <span className="w-1.5 h-1.5 rounded-full bg-red-500 hidden sm:block"></span>
          <span className="hidden sm:inline">Threat Response Team</span>
        </div>
        <p className="text-slate-300 text-xs sm:text-sm border-l-4 border-red-900/50 pl-3 pr-4 py-2 bg-black/30 rounded-r-md">
          Our Security Operations Center (SOC) team is staffed by dedicated security professionals providing 24/7 monitoring 
          and response to cyber threats. The team works in three shifts to ensure continuous coverage and protection for your 
          organization's digital assets.
        </p>
      </div>

      {/* SOC Department Head - Highlight Card */}
      <div className="mb-8 sm:mb-12">
        <h2 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 flex items-center before:content-['//'] before:text-red-600 before:mr-2 after:content-[''] after:h-px after:flex-grow after:bg-gradient-to-r after:from-red-900/50 after:to-transparent after:ml-3">
          <UserCheck className="h-4 w-4 sm:h-5 sm:w-5 mr-2 text-red-600" />
          SOC Department Head
        </h2>

        <div className="group relative overflow-hidden rounded-xl border border-slate-800 bg-gradient-to-br from-slate-950/90 to-black/95 backdrop-blur-sm transition-all duration-300 hover:border-red-700/50 hover:shadow-[0_0_40px_rgba(185,28,28,0.2)] hover:-translate-y-1">
          <div className="absolute inset-0 bg-gradient-to-br from-red-900/10 to-purple-900/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-900 via-red-600 to-red-900 opacity-30 group-hover:opacity-80 transition-opacity"></div>
          
          <div className="p-4 sm:p-6 flex flex-col sm:flex-row gap-4 sm:gap-6 items-center relative">
            <div className="relative">
              <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-xl overflow-hidden border-4 border-red-900/30 group-hover:border-red-900/50 transition-colors">
                <img 
                  src={teamData.head.avatar} 
                  alt={teamData.head.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-2 -right-2 bg-red-900/80 px-2 py-1 rounded-lg border border-red-700 text-xs text-white">
                <Clock className="h-3 w-3 inline-block mr-1" />
                24/7
              </div>
            </div>
            
            <div className="flex-1 text-center sm:text-left">
              <h3 className="text-xl sm:text-2xl font-bold mb-1">{teamData.head.name}</h3>
              <p className="text-red-400 mb-3">{teamData.head.role}</p>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-4">
                <div className="bg-black/40 p-2 rounded-lg border border-slate-800/80 flex items-center">
                  <Mail className="h-4 w-4 text-red-500 mr-2" />
                  <span className="text-sm">{teamData.head.email}</span>
                </div>
                <div className="bg-black/40 p-2 rounded-lg border border-slate-800/80 flex items-center">
                  <Phone className="h-4 w-4 text-red-500 mr-2" />
                  <span className="text-sm">{teamData.head.phone}</span>
                </div>
              </div>
              
              <p className="text-sm text-slate-400 bg-black/30 p-3 rounded-lg border border-slate-800/60">
                As Head of the SOC Department, {teamData.head.name} oversees all security operations, 
                manages the team across all shifts, and ensures consistent threat monitoring and response standards.
                Available 24/7 for critical security incidents and strategic security decisions.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Shift Selection Tabs */}
      <div className="mb-6">
        <div className="flex flex-wrap gap-2">
          <button 
            onClick={() => setActiveShift('all')}
            className={`px-4 py-2 rounded-lg border transition-all ${
              activeShift === 'all' 
              ? 'bg-red-900/20 border-red-900/40 text-white' 
              : 'bg-slate-900/50 border-slate-800/60 text-slate-400 hover:bg-red-900/10 hover:border-red-900/30'
            }`}
          >
            <Users className="h-4 w-4 inline-block mr-1.5" />
            All Teams
          </button>
          <button 
            onClick={() => setActiveShift('morning')}
            className={`px-4 py-2 rounded-lg border transition-all ${
              activeShift === 'morning' 
              ? 'bg-red-900/20 border-red-900/40 text-white' 
              : 'bg-slate-900/50 border-slate-800/60 text-slate-400 hover:bg-red-900/10 hover:border-red-900/30'
            }`}
          >
            <Clock className="h-4 w-4 inline-block mr-1.5" />
            Morning Shift
          </button>
          <button 
            onClick={() => setActiveShift('evening')}
            className={`px-4 py-2 rounded-lg border transition-all ${
              activeShift === 'evening' 
              ? 'bg-red-900/20 border-red-900/40 text-white' 
              : 'bg-slate-900/50 border-slate-800/60 text-slate-400 hover:bg-red-900/10 hover:border-red-900/30'
            }`}
          >
            <Clock className="h-4 w-4 inline-block mr-1.5" />
            Evening Shift
          </button>
          <button 
            onClick={() => setActiveShift('night')}
            className={`px-4 py-2 rounded-lg border transition-all ${
              activeShift === 'night' 
              ? 'bg-red-900/20 border-red-900/40 text-white' 
              : 'bg-slate-900/50 border-slate-800/60 text-slate-400 hover:bg-red-900/10 hover:border-red-900/30'
            }`}
          >
            <Clock className="h-4 w-4 inline-block mr-1.5" />
            Night Shift
          </button>
        </div>
      </div>

      {/* Team Members Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-8">
        {getVisibleTeamMembers().map(member => (
          <div 
            key={member.id}
            className="group relative overflow-hidden rounded-lg border border-slate-800 bg-gradient-to-br from-slate-950/90 to-black/95 backdrop-blur-sm transition-all duration-300 hover:border-red-700/30 hover:shadow-[0_0_30px_rgba(185,28,28,0.15)] hover:-translate-y-1"
          >
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-900 via-red-600 to-red-900 opacity-30 group-hover:opacity-80 transition-opacity"></div>
            
            <div className="p-4 flex gap-3 items-center">
              <div className="relative">
                <div className="w-16 h-16 rounded-lg overflow-hidden border-2 border-red-900/30 group-hover:border-red-900/50 transition-colors">
                  <img 
                    src={member.avatar} 
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-1 -right-1 bg-red-900/80 px-1.5 py-0.5 rounded-md border border-red-700 text-[10px] text-white">
                  {member.shift}
                </div>
              </div>
              
              <div className="flex-1">
                <h3 className="font-bold text-lg">{member.name}</h3>
                <p className="text-red-400 text-sm">{member.role}</p>
              </div>
            </div>
            
            <div className="px-4 pb-4 pt-0">
              <div className="grid grid-cols-1 gap-2">
                <div className="bg-black/40 p-2 rounded border border-slate-800/80 flex items-center text-sm">
                  <Mail className="h-3.5 w-3.5 text-red-500 mr-2 flex-shrink-0" />
                  <span className="truncate">{member.email}</span>
                </div>
                <div className="bg-black/40 p-2 rounded border border-slate-800/80 flex items-center text-sm">
                  <Phone className="h-3.5 w-3.5 text-red-500 mr-2 flex-shrink-0" />
                  <span>{member.phone}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SOC Team Information */}
      <div className="bg-slate-950/70 border border-slate-800 rounded-lg p-4 sm:p-6 mb-8">
        <h2 className="text-lg sm:text-xl font-bold mb-3 flex items-center">
          <img src="https://pub-0f77feecf89849e2bd80779e26ad94bb.r2.dev/shieldxgif.gif" alt="ShieldX" className="h-5 w-5 mr-2" />
          SOC Team Operations
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
          <div className="bg-black/40 p-3 rounded-lg border border-slate-800">
            <h3 className="font-bold text-red-500 flex items-center mb-2">
              <Clock className="h-4 w-4 mr-2" />
              Morning Shift (8:00 - 16:00)
            </h3>
            <p className="text-sm text-slate-300">
              Handles the transition from night operations, conducts initial daily assessments,
              coordinates with international teams, and performs scheduled security audits.
            </p>
          </div>
          
          <div className="bg-black/40 p-3 rounded-lg border border-slate-800">
            <h3 className="font-bold text-red-500 flex items-center mb-2">
              <Clock className="h-4 w-4 mr-2" />
              Evening Shift (16:00 - 00:00)
            </h3>
            <p className="text-sm text-slate-300">
              Manages peak business hours traffic, responds to day-generated alerts,
              conducts threat hunting activities, and prepares evening security briefings.
            </p>
          </div>
          
          <div className="bg-black/40 p-3 rounded-lg border border-slate-800">
            <h3 className="font-bold text-red-500 flex items-center mb-2">
              <Clock className="h-4 w-4 mr-2" />
              Night Shift (00:00 - 8:00)
            </h3>
            <p className="text-sm text-slate-300">
              Monitors systems during reduced-activity hours, performs scheduled maintenance,
              runs comprehensive scans, and prepares daily reports for the morning shift.
            </p>
          </div>
        </div>
        
        <div className="bg-black/50 p-4 rounded-lg border border-red-900/30 text-sm">
          <p className="mb-2">
            Our SOC team operates 24/7 in three shifts to ensure continuous monitoring and immediate response to security incidents.
            Each team member is a certified security professional with specialized training in threat detection, incident response,
            and security analysis.
          </p>
          <p>
            The team utilizes ShieldX's AlertStrike SIEM & XDR Solution to monitor, detect, and respond to security threats in real-time.
            For emergency security incidents, all team members can be reached via their direct contact information.
          </p>
        </div>
      </div>
    </main>
  );
};

export default Team;